// 身份
const state = {
  defaultAvatar: `this.src="${require("@/assets/common/avatar.png")}"`, //默认活动头像
  userInfo: JSON.parse(sessionStorage.getItem('userinfo')), // 用户信息
  token: sessionStorage.getItem('token'), // 用户信息
};

const mutations = {
  getUserInfo(state, res) {
    state.userInfo = res;
  }
};

export default {
  state,
  mutations
};